import React from "react";
import { Edit as EditIcon, Delete as DeleteIcon, PublishedWithChangesRounded, } from "@mui/icons-material"; import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Card, CardContent, CardHeader, Grid, IconButton, TextField, Tooltip, Typography, } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import { catalogoSave, catalogoDelete, catalogoUpdate } from "../../../services/CatalogoServices";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import MUIXDataGrid from "../../Ayuda/MUIXDataGrid";
import { crudService } from "../../../services/CrudService";

export interface FondosInterface {
  uuid: string;
  Cve: string;
  Nombre: string;
  Descripcion: string;
  creadopor: string;
  modificadopor: string;
  eliminadopor: string;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 5,
  p: 2,
};

export default function Municipios() {
  const TITULO = "Catálogo de Municipios";
  const TITULODETALLE = "Detalle de Municipios";
  const BASEURL = `catalogos/municipios`;
  document.title = TITULO;

  const navigate = useNavigate();
  const [id, setid] = useState("");
  const [nombre, setNombre] = useState("");
  const [clave, setClave] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSave = async () => {
    try {
      const newPublicacion = { nombre, clave };
      await crudService(BASEURL, 'crear', null, newPublicacion).then(
        () => window.location.reload()
      )
    } catch (error) {
      console.error("Error al crear el Municipio:", error);
    }
  };


  const handleDelete = async (id: string) => {
    Swal.fire({
      icon: "warning",
      title: "Dar de baja",
      text: "¿Estás seguro de que deseas dar de baja este Municipio?",
      showCancelButton: true,
      confirmButtonColor: "#15212f",
      cancelButtonColor: "#bda889",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await crudService(BASEURL, "baja", id);
          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Baja",
              text: "El Municipio ha sido dada de baja.",
              confirmButtonColor: "#15212f",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "No se pudo dar de baja el Municipio.",
              confirmButtonColor: "#15212f",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo dar de baja el Municipio.",
            confirmButtonColor: "#15212f",
          });
        }
      }
    });
  };

  const handleRecover = async (id: string) => {
    Swal.fire({
      icon: "info",
      title: "Recuperar",
      text: "¿Estás seguro de que deseas recuperar este Municipio?",
      showCancelButton: true,
      confirmButtonColor: "#15212f",
      cancelButtonColor: "#bda889",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await crudService(BASEURL, "recupera", id);
          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Recuperado",
              text: "El Municipio ha sido recuperada.",
              confirmButtonColor: "#15212f",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "No se pudo recuperar el Municipio.",
              confirmButtonColor: "#15212f",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo recuperar el Municipio.",
            confirmButtonColor: "#15212f",
          });
        }
      }
    });
  };

  const handleUpdate = async () => {
    if (nombre === "") {
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        text: "Favor de completar los campos",
        confirmButtonColor: "#15212f",
      });
    } else {
      try {
        const data = { nombre }
        const response = await crudService(BASEURL, "actualizar", id, data);
        if (response.success) {
          Swal.fire({
            icon: "success",
            title: "Recuperado",
            text: "La Municipio ha sido actualizada.",
            confirmButtonColor: "#15212f",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.message || "No se pudo actualizar la Municipio.",
            confirmButtonColor: "#15212f",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar la Municipio.",
          confirmButtonColor: "#15212f",
        });
      }
    }
  };

  const columns = [
    {
      field: "acciones",
      headerName: "Acciones",
      width: 180,
      headerAlign: "left",
      hideable: false,
      renderCell: (cellValues: any) => {
        return (
          <Box>
            <Tooltip title={"Editar"}>
              <IconButton color="inherit"
                onClick={() => {
                  setid(cellValues.row.id);
                  setNombre(cellValues.row.nombre);
                  setClave(cellValues.row.clave);
                  handleOpen();
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            {
              cellValues.row.estatus == 'ACTIVO' ?
                <Tooltip title={"Eliminar"}>
                  <IconButton color="inherit"
                    onClick={() => { handleDelete(cellValues.row.id); }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title={"Recuperar"}>
                  <IconButton color="inherit"
                    onClick={() => { handleRecover(cellValues.row.id); }}
                  >
                    <PublishedWithChangesRounded />
                  </IconButton>
                </Tooltip>
            }
          </Box>
        );
      },
    },
    {
      field: "clave",
      headerName: "Clave",
      width: 150,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "nombre",
      headerName: "Nombre",
      width: 200,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "estatus",
      headerName: "Estatus",
      width: 150,
      hideable: false,
      headerAlign: "left",
    },
  ];

  const camposCsv = ["Cve", "nombre", "estatus"];
  const [rows, setRows] = useState([]);
  const getAllMunicipios = async () => {
    const response = await crudService(BASEURL, 'obtener');
    if (response?.data) {
      setRows(response.data)
    }
  };

  useEffect(() => {
    getAllMunicipios();
  }, []);

  // esto es para que se ejecuten todo los get de los listados solo cuando se abra la modal,y que limpie las variables cuando se salga de la modal

  useEffect(() => {
    // Limpieza de campos al cerrar la modal
    if (!open) {
      setNombre("");
      setClave("");
    }
  }, [open]);
  return (
    // contenedor principal
    <Grid container sx={{}}>
      <BreadcrumbBar
        links={[
          { texto: 'Inicio', link: '/admin' },
          { texto: 'Catálogos', link: '/admin/catalogos' }
        ]
        }
        Titulo={TITULO}
      />
      <Grid container xs={12} justifyContent={"center"}>
        <Grid item xs={12} md={12} mt={2}>
          <Card sx={{ p: 0, boxShadow: 8 }}>
            <CardHeader sx={{ position: "absolute", fontFamily: "MontserratSemiBold" }} />
            <Typography variant="h5" sx={{ paddingTop: "1%", paddingLeft: "1%" }}>  {TITULO} </Typography>
            <CardContent sx={{ fontFamily: "MontserratBold", bgcolor: "" }}>
              <Box display="flex" justifyContent="flex-end">
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "right",
                    justifyContent: "right",
                    paddingBottom: "2%",
                    paddingRight: "1%",
                  }}
                >
                  <Button
                    onClick={handleOpen}
                    variant="contained"
                    sx={{ margin: "1%", color: "#FFFFFF" }}
                  >
                    <Typography
                      sx={{
                        color: "#FFFFFF", "&:hover": { color: "#15212f" },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize: "100%",
                      }}
                    >
                      Agregar
                    </Typography>
                  </Button>
                  <Button
                    onClick={() => navigate(-1)}
                    color="secondary"
                    sx={{ margin: "1%" }}
                    variant="contained">
                    <Typography
                      sx={{
                        color: "#ffffff",
                        "&:hover": {
                          color: "#15212f",
                        },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize: "100%",
                      }}>
                      Cancelar
                    </Typography>
                  </Button>
                </Grid>
              </Box>
              <MUIXDataGrid id={Math.random} columns={columns} rows={rows} camposCsv={camposCsv} />
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} display="flow">
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="h5" sx={{ padding: "1%" }}>
                          {TITULODETALLE}
                        </Typography>
                      </Box>
                    </Grid>
                    
                      <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          inputProps={{ maxLength: 256 }}
                          label="Clave"
                          size="small"
                          variant="outlined"
                          value={clave}
                          disabled={id !== "" ? true : false}
                          onChange={(v) => { setClave(v.target.value); }}
                        />
                      </Box>
                      </Grid>
                      <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          inputProps={{ maxLength: 256 }}
                          label="Nombre"
                          size="small"
                          variant="outlined"
                          value={nombre}
                          onChange={(v) => { setNombre(v.target.value); }}
                        />
                      </Box>
                      </Grid>
                    
                    <Grid item xs={12}>
                      <Box
                        maxWidth="100%"
                        paddingTop={2}
                        paddingBottom={2}
                        display="flex"
                        justifyContent="end"
                      >
                        <Button
                          onClick={() => {
                            if (id === "") {
                              handleSave()
                            } else {
                              handleUpdate()
                            }
                          }
                          }
                          variant="contained"
                          sx={{ margin: "1%", color: "white", "&:hover": { color: "#15212f", }, }}
                        >
                          Guardar
                        </Button>
                        <Button
                          onClick={handleClose}
                          variant="contained"
                          color="secondary"
                          sx={{ margin: "1%", color: "white", "&:hover": { color: "#15212f", }, }}
                        >
                          Cancelar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}